"use client";

// imports common cards
import { IDecklistV2 } from "@/models/decklist";
import { useLeaders } from "@/hooks/useLeaders";
import {
  Avatar,
  AutocompleteSection,
  Image,
  Button,
  Select,
  SelectItem,
} from "@heroui/react";
import { IconChessKing } from "@tabler/icons-react";
import { Autocomplete, AutocompleteItem } from "@heroui/autocomplete";
import { getLeaderSquare } from "@/lib/getLeaderImage";
// import LeaderFilter2 from "./LeaderFilter2";
import LeaderFilter4 from "@/components/DeckBuilder/LeaderFilter4";

import type { DeckCardsMap } from "@/interfaces/DeckIdentity";
export type { DeckCardsMap } from "@/interfaces/DeckIdentity";

export function getDeckCardsMap(decks: IDecklistV2[]): DeckCardsMap {
  let deckCardsMap: DeckCardsMap = {};
  for (const deck of decks) {
    const leaderId = deck.leader_id;
    if (!(leaderId in deckCardsMap)) {
      deckCardsMap[leaderId] = {
        count: 0,
        cards: [],
      };
    }
    if (deck.decklist) {
      const cards = deck.decklist.split(";");
      const cardIds = cards.map((x) => {
        return x.split("x")[1];
      });
      for (const cardId of cardIds) {
        if (!deckCardsMap[leaderId].cards.includes(cardId)) {
          deckCardsMap[leaderId].cards.push(cardId);
        }
      }
      deckCardsMap[leaderId].count += 1;
    }
  }
  return deckCardsMap;
}

export default function DeckCommonCardsFilter({
  deckCardsMap,
  selected,
  setSelected,
  label,
  width = "200px",
}: {
  deckCardsMap: DeckCardsMap;
  selected: any;
  setSelected: any;
  label?: string;
  width?: string;
}) {
  const { leaders } = useLeaders();

  // Helper function to get leader data
  const getLeaderData = (leaderId: string) => {
    const normalizedId = leaderId?.toUpperCase();
    return leaders[normalizedId] || { name: "Unknown", color: "Unknown" };
  };

  const getDeckFullId = (id: string) => {
    return `${getLeaderData(id).name}:${id}`;
  };

  let items = [];

  for (const [k, v] of Object.entries(deckCardsMap)) {
    items.push({
      id: k,
      idFull: getDeckFullId(k),
      key: k,
      name: getLeaderData(k).name,
      value: getLeaderData(k).name,
      color: getLeaderData(k).color,
      count: v.count,
    });
  }

  items = items.sort((a, b) => {
    return b.count - a.count;
  });

  return (
    <LeaderFilter4
      leaderIds={items.map((item) => item.id)}
      selected={selected}
      setSelected={setSelected}
      sortByName={false}
      width={width}
      label={label}
    />
  );
}
